import type { TimelineFilters } from '../../store/auditStore';

interface Props {
  filters: TimelineFilters;
  onChange: (f: TimelineFilters) => void;
  onSubmit: () => void;
}

const ENTITY_TYPES = ['', 'Person', 'Organization', 'PersonSportTeam', 'User'];

const inputCls =
  'border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 rounded px-2 py-1 text-sm';

export function AuditFilterBar({ filters, onChange, onSubmit }: Props) {
  function set<K extends keyof TimelineFilters>(key: K, value: TimelineFilters[K]) {
    onChange({ ...filters, [key]: value || undefined });
  }
  return (
    <div className="flex flex-wrap items-end gap-3 p-3 bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:border-gray-700 rounded-md">
      <label className="flex flex-col text-xs text-gray-600 dark:text-gray-400">
        Source
        <input
          className={`${inputCls} w-40`}
          placeholder="user, sync:nightly..."
          value={filters.source ?? ''}
          onChange={(e) => set('source', e.target.value)}
        />
      </label>
      <label className="flex flex-col text-xs text-gray-600 dark:text-gray-400">
        Entity type
        <select
          className={`${inputCls} w-40`}
          value={filters.entityType ?? ''}
          onChange={(e) => set('entityType', e.target.value)}
        >
          {ENTITY_TYPES.map((t) => (
            <option key={t} value={t}>
              {t || '(any)'}
            </option>
          ))}
        </select>
      </label>
      <label className="flex flex-col text-xs text-gray-600 dark:text-gray-400">
        Field name
        <input
          className={`${inputCls} w-32`}
          value={filters.fieldName ?? ''}
          onChange={(e) => set('fieldName', e.target.value)}
        />
      </label>
      <label className="flex flex-col text-xs text-gray-600 dark:text-gray-400">
        From
        <input
          type="datetime-local"
          className={inputCls}
          value={filters.from ?? ''}
          onChange={(e) =>
            set('from', e.target.value ? new Date(e.target.value).toISOString() : undefined)
          }
        />
      </label>
      <label className="flex flex-col text-xs text-gray-600 dark:text-gray-400">
        To
        <input
          type="datetime-local"
          className={inputCls}
          value={filters.to ?? ''}
          onChange={(e) =>
            set('to', e.target.value ? new Date(e.target.value).toISOString() : undefined)
          }
        />
      </label>
      <button
        onClick={onSubmit}
        className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-3 py-1.5 rounded"
      >
        Apply
      </button>
    </div>
  );
}
